import styled from 'styled-components';
import { Grid } from '@elliemae/ds-grid';

export const LifebuoyIcon = styled.svg`
  width: ${({ theme }) => theme.space.xl};
  height: ${({ theme }) => theme.space.xl};
  fill: none;
  stroke: ${({ theme }) => theme.colors.neutral[500]};
  stroke-width: 3;
`;

export const DashboardLayout = styled(Grid)`
  overflow: hidden;
`;

export const TableViewport = styled.div`
  min-height: 0;
  overflow: hidden;
`;
